import { connect } from "react-redux";
import SubTotal from "./SubTotal";
import { getTotalPriceValue } from "../../../../state/modules/bag";

const mapStateToProps = state => {
  return {
    value: getTotalPriceValue(state)
  };
};

export default connect(mapStateToProps)(SubTotal);



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/SubTotal/index.js